/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `EVYDEJ` - eVýdej
 *   * `COUNTER` - Přepážka
 * ```
 */
export const OriginEnum = { EVYDEJ: 'EVYDEJ', COUNTER: 'COUNTER' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OriginEnum = ValuesOf<typeof OriginEnum>;

export type OriginEnumRequest = OriginEnum;
export type OriginEnumResponse = OriginEnum;
